import * as React from 'react';
import RevenuePredictionContainer from '../../containers/RevenuePredictionContainer/RevenuePredictionContainer';

const RevenuePredictionScene: React.FC = () => <RevenuePredictionContainer />;

export default RevenuePredictionScene;
